/**
 * Utility function, creates AoPS.Contest if it doesn't exist already.
 */

AoPS.Utils.initKeyChain(AoPS, "Contests", "Models");

AoPS.Contests.Models = (function (Models) {
	// The generic models in this file will be using this format.
	Models.GenericContestModelPrototype = Backbone.Model.extend({
		// This method is called when the model is first created.
		initialize: function () {},
		// This fetch usually gets explicitly called after the model has been populated or updated.
		fetch: function () {},
		// getAll: function(key) {
		// 	if (this.get(key) instanceof Backbone.Collection) {
		// 		return this.get(key);
		// 	}
		// },
		getWhere: function (key, condition) {
			if (this.get(key) instanceof Backbone.Collection) {
				return this.get(key)[_.isFunction(condition) ? "find" : "findWhere"](
					condition
				);
			}
		},
		// This is sort of a generic collection manager, it should be extended
		// to make something that actually makes sense.
		addOrUpdate: function (
			col_name,
			col_options,
			Model,
			objects,
			object_id,
			options,
			extra
		) {
			if (!(this.get(col_name) instanceof Backbone.Collection)) {
				this.set(col_name, new (Backbone.Collection.extend({model: Model}))());
			}

			_.each(
				_.isArray(objects) ? objects : [objects],
				_.bind(function (object) {
					var this_object = this.getWhere(
						col_name,
						_.reduce(
							_.isArray(object_id) ? object_id : [object_id],
							function (where, key) {
								where[key] = object[key];
								return where;
							},
							{}
						)
					);
					if (this_object) {
						this_object.set(object);
						if (_.isFunction(this_object.fetch)) {
							this_object.fetch();
						}
						this_object.trigger("fetch");
					} else {
						this_object = new Model(object);
						this_object.set(extra);
						if (_.isFunction(this_object.fetch)) {
							this_object.fetch();
						}
						this_object.trigger("fetch");
						this.get(col_name).add(this_object, options || {});
					}
				}, this)
			);
		},
	});

	Models.GenericMaster = Models.GenericContestModelPrototype.extend({
		/**
		 * Returns the version number of the browser if the browser is IE/Edge,
		 * where Edge returns 12. Other browsers return false.
		 *
		 * @returns {number|false} A number if a version of IE (12 being Edge), or false if not IE.
		 */
		detectIE() {
			var ua = window.navigator.userAgent;

			var msie = ua.indexOf("MSIE ");
			if (msie > 0) {
				// IE 10 or older => return version number
				return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
			}

			var trident = ua.indexOf("Trident/");
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf("rv:");
				return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
			}

			var edge = ua.indexOf("Edge/");
			if (edge > 0) {
				// Edge (IE 12+) => return version number
				return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
			}

			// other browser
			return false;
		},
		addOrUpdateContest: function (objects, options) {
			this.addOrUpdate(
				"contests",
				{},
				Models.Contest,
				objects,
				"contest_id",
				options,
				{master: this}
			);

			if (!this.get("contests") || !this.get("contests").models) {
				return;
			}

			// If a contest belongs to academy, its hash will begin with acadproblemsolvers
			//  Sets a value to determine if a contest is academy or not in handlebars
			this.get("contests").models.forEach((model) => {
				var contest_hash = model.get("contest_hash");
				if (!contest_hash) {
					return;
				}
				var match_academy = contest_hash.match(/acadproblemsolvers.*/);
				var match_academy_championship = contest_hash.match(
					/acadproblemsolvers-championship.*/
				);

				model.set("is_academy", match_academy ? true : false);
				model.set(
					"is_academy_championship",
					match_academy_championship ? true : false
				);
			});
		},
		addOrUpdateContestRound: function (objects, options) {
			this.addOrUpdate(
				"contest_rounds",
				{},
				Models.ContestRound,
				objects,
				"contest_round_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestWindow: function (objects, options) {
			this.addOrUpdate(
				"contest_windows",
				{},
				Models.ContestWindow,
				objects,
				"contest_window_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestProblem: function (objects, options) {
			this.addOrUpdate(
				"contest_problems",
				{},
				Models.ContestProblem,
				objects,
				"contest_problem_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestRegistration: function (objects, options) {
			this.addOrUpdate(
				"contest_registrations",
				{},
				Models.ContestRegistration,
				objects,
				"contest_registration_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestPlayFile: function (objects, options) {
			this.addOrUpdate(
				"contest_play_files",
				{},
				Models.ContestPlayFile,
				objects,
				"file_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestTeam: function (objects, options) {
			this.addOrUpdate(
				"contest_teams",
				{},
				Models.ContestWindow,
				objects,
				"contest_team_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestTeamInvitation: function (objects, options) {
			this.addOrUpdate(
				"contest_team_invitations",
				{},
				Models.ContestTeamInvitation,
				objects,
				"contest_team_invitation_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestCms: function (objects, options) {
			this.addOrUpdate(
				"contest_cms",
				{},
				Models.ContestCms,
				objects,
				"file",
				options,
				{master: this}
			);
		},
		addOrUpdateContestFlavor: function (objects, options) {
			this.addOrUpdate(
				"contest_flavors",
				{},
				Models.ContestFlavor,
				objects,
				"flavor_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestProblemInputFormat: function (objects, options) {
			this.addOrUpdate(
				"contest_problem_input_formats",
				{},
				Models.ContestProblemInputFormat,
				objects,
				"format_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestPortalHost: function (objects, options) {
			this.addOrUpdate(
				"contest_portal_hosts",
				{},
				Models.ContestPortalHost,
				objects,
				"portal_host_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestPortalInvitation: function (objects, options) {
			this.addOrUpdate(
				"contest_portal_invitations",
				{},
				Models.ContestPortalInvitation,
				objects,
				"portal_invitation_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestPortalUser: function (objects, options) {
			this.addOrUpdate(
				"contest_portal_users",
				{},
				Models.ContestPortalUser,
				objects,
				"portal_user_id",
				options,
				{master: this}
			);
		},
		addOrUpdateContestPortalRequestedUser: function (objects, options) {
			this.addOrUpdate(
				"contest_portal_requested_users",
				{},
				Models.ContestPortalRequestedUser,
				objects,
				"portal_requested_user_id",
				options,
				{master: this}
			);
		},
	});

	Models.Contest = Models.GenericContestModelPrototype.extend({
		computeParentContest: function () {
			return this.get("master").getWhere("contests", {
				contest_id: this.get("parent_contest_id"),
			});
		},
		computeChildrenContests: function () {
			return this.get("master")
				.get("contests")
				.where({
					parent_contest_id: this.get("contest_id"),
				});
		},
		computeSortedRounds: function (options) {
			return (
				this.get("contest_rounds") || this.get("master").get("contest_rounds")
			)
				.filter(
					_.bind(function (contest_round) {
						return (
							!contest_round.get("deleted_at") &&
							contest_round.get("contest_id") === this.get("contest_id")
						);
					}, this)
				)
				.sort(function (a, b) {
					var indexes = ["order", "contest_round_id"];
					for (var i = 0; i < indexes.length; i++) {
						var index_name = indexes[i];
						if (a.get(index_name) === 0 && b.get(index_name) !== 0) {
							return 1;
						} else if (a.get(index_name) !== 0 && b.get(index_name) === 0) {
							return -1;
						} else if (a.get(index_name) !== b.get(index_name)) {
							return a.get(index_name) - b.get(index_name);
						}
					}
					return 0;
				});
		},
		/**
		 * A contest is standalone if it has no parent or children (e.g. Putnam)
		 */
		isStandalone: function () {
			return (
				!this.computeParentContest() &&
				this.computeChildrenContests().length === 0 &&
				this.get("flavor").get("is_collection") === 0
			);
		},
	});

	Models.ContestRound = Models.GenericContestModelPrototype.extend({
		computeSortedProblems: function (options) {
			return (
				this.get("contest_problems") ||
				this.get("master").get("contest_problems")
			)
				.filter(
					_.bind(function (problem) {
						return (
							!problem.get("deleted_at") &&
							problem.get("contest_round_id") === this.get("contest_round_id")
						);
					}, this)
				)
				.sort(function (a, b) {
					var indexes = ["segment_index", "item_index", "sequence_index"];
					for (var index_name of indexes) {
						if (a.get(index_name) === 0 && b.get(index_name) !== 0) {
							return -1;
						} else if (a.get(index_name) !== 0 && b.get(index_name) === 0) {
							return 1;
						} else if (a.get(index_name) !== b.get(index_name)) {
							return a.get(index_name) - b.get(index_name);
						}
					}
					return 0;
				});
		},
		computeSegmentedProblems: function (options) {
			var problems = (
				this.get("contest_problems") ||
				this.get("master").get("contest_problems")
			).filter(
				_.bind(function (problem) {
					return (
						!problem.get("deleted_at") &&
						problem.get("contest_round_id") === this.get("contest_round_id")
					);
				}, this)
			);

			return _.map(
				_.uniq(
					_.map(problems, function (problem) {
						return problem.get("segment_index");
					})
				).sort(function (a, b) {
					return a - b;
				}),
				_.bind(function (segment_index, key) {
					var segment = new Models.ContestSegment(
						_.extend(
							{
								contest_id: this.get("contest_id"),
								contest_round_id: this.get("contest_round_id"),
								segment_index: segment_index,
								contest_round: this,
							},
							this.get("segments")[key] || {}
						)
					);
					segment.set("contest_round", this);
					segment
						.assignProblems(
							_.filter(problems, function (problem) {
								return problem.get("segment_index") === segment_index;
							})
						)
						.fetch();
					segment.trigger("fetch");
					return segment;
				}, this)
			);
		},
	});

	Models.ContestWindow = Models.GenericContestModelPrototype.extend({
		getIntervalNames: function () {
			return [
				"contest_window",
				"contest_preview",
				"unofficial_registration",
				"unofficial_individual_contest",
				"unofficial_team_contest",
				"official_registration",
				"official_individual_contest",
				"official_team_contest",
				"practice_test",
			];
		},
		getStatusNames: function () {
			return [
				"start_contest_timer",
				"show_leaderboard",
				"cutoff_leaderboard",
				"show_review",
			];
		},
	});

	Models.ContestProblem = Models.GenericContestModelPrototype.extend({});

	Models.ContestSegment = Models.GenericContestModelPrototype.extend({
		assignProblems: function (problems) {
			this.set(
				"items",
				new (Backbone.Collection.extend({
					model: Models.ContestProblemSequence,
				}))(
					_.map(
						_.uniq(
							_.map(problems, function (problem) {
								return problem.get("item_index");
							})
						).sort(function (a, b) {
							return a - b;
						}),
						_.bind(function (item_index, key) {
							var item = new Models.ContestSegmentItem({
								contest_id: this.get("contest_id"),
								contest_round_id: this.get("contest_round_id"),
								segment_index: this.get("segment_index"),
								item_index: item_index,
							});
							item.set("contest_segment", this);
							item
								.assignProblems(
									_.filter(problems, function (problem) {
										return problem.get("item_index") === item_index;
									})
								)
								.fetch();
							item.trigger("fetch");
							return item;
						}, this)
					)
				)
			);
			return this;
		},
	});

	// Segments have multiple items, each of which can have multiple problems.
	// Usually, an item will have only one problem.
	Models.ContestSegmentItem = Models.GenericContestModelPrototype.extend({
		assignProblems: function (problems) {
			this.set(
				"problems",
				new (Backbone.Collection.extend({
					model: Models.ContestProblem,
				}))(
					problems.slice(0).sort(function (a, b) {
						return a.get("sequence_index") - b.get("sequence_index");
					})
				)
			);
			this.get("problems").each(
				_.bind(function (problem) {
					problem.set("contest_segment_item", this);
				}, this)
			);
			return this;
		},
	});

	Models.ContestRegistration = Models.GenericContestModelPrototype.extend({});

	Models.ContestTeam = Models.GenericContestModelPrototype.extend({});

	Models.ContestTeamInvitation = Models.GenericContestModelPrototype.extend({});

	Models.ContestPlayFile = Models.GenericContestModelPrototype.extend({});

	Models.ContestFlavor = Models.GenericContestModelPrototype.extend({});

	Models.ContestProblemInputFormat = Models.GenericContestModelPrototype.extend(
		{}
	);

	Models.ContestCms = Models.GenericContestModelPrototype.extend({
		getHbOutput: function (template_selector, vars) {
			var $handlebars = $("<div />").html(this.get("handlebars"));
			var $template = $handlebars.find(template_selector);
			if ($template.length) {
				return Handlebars.compile($template.html())(vars);
			}
		},
	});

	Models.ContestPortalHost = Models.GenericContestModelPrototype.extend({
		fetch: function () {
			this.set("type_is_" + this.get("host_type"), 1);
		},
	});

	Models.ContestPortalInvitation = Models.GenericContestModelPrototype.extend({
		fetch: function () {
			this.set("type_is_" + this.get("invitation_type"), 1);
		},
	});

	Models.ContestPortalUser = Models.GenericContestModelPrototype.extend({
		fetch: function () {
			this.set("type_is_" + this.get("user_type"), 1);
		},
	});

	Models.ContestPortalRequestedUser =
		Models.GenericContestModelPrototype.extend({
			fetch: function () {
				this.set("type_is_" + this.get("user_type"), 1);
			},
		});

	return Models;
})(AoPS.Contests.Models);
